import { W as WuiTextarea$1, d as defineCustomElement$1 } from './p-CcMI_rq6.js';

const WuiTextarea = WuiTextarea$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTextarea, defineCustomElement };
